<template>
  <div id="footer">
    <div class="footer-main">
      <div class="footer-main-block footer-container">
        <div class="footer-mark">
          <p>官方声明</p>
          <p><span>Peet’s Coffee</span>从未发布、声明、开放任何形式的包括但不仅限于加盟或特许经营或代理等业务合作。若任何网站、APP或媒体上发现关于我司包括但不仅限于加盟、特许经营或代理的信息均系伪造，存在欺诈风险。您在网上搜到或线下获取的所有我司关于包括但不仅限于于加盟、特许经营、代理等信息均非<span>Peet’s</span>官方信息，均系未经授权的信息，均为虚假信息，请大家谨防上当受骗，我司对此将不再承担任何法律责任。
          </p>
          <p>我司拥有包括且不仅限于“<span>Peet’s Coffee</span>”“皮爷咖啡“等的品牌商标权，对于任何企业或个人侵犯“<span>Peet’s Coffee</span>”“皮爷咖啡“
            注册商标专用权的行为，我们将保留证据并坚决予以打击，同时依法追究相关侵害主体的法律责任。</p>
          <p>特此声明！</p>
        </div>
        <div class="footer-logo">
          <img src="@/assets/img/logo_yellow.png" />
        </div>
        <div class="text-nav">
          <div class="text-nav-l text-list">
            <div class="text-item" @mouseover="showWechat" @mouseout="hideWechat">微信
              <div class="text-pop animated fadeIn" v-show="isWechatPopShow">
                <img src="@/assets/img/footer_wecode.jpg" />
              </div>
            </div>
            <div class="text-item" @click="goLink('https://weibo.com/p/1006066360528436/home')">微博</div>
            <div class="text-item"
              @click="goLink('https://www.xiaohongshu.com/user/profile/5bc42ded1a4d0e000186adff?xhsshare=CopyLink&appuid=5bc42ded1a4d0e000186adff&apptime=1671514408')">
              小红书</div>
            <div class="text-item" @click="goLink('https://peets.tmall.com/shop/view_shop.htm')">天猫</div>
            <div class="text-item" @click="goLink('https://mall.jd.com/index-1000382662.html')">京东</div>
            <div class="text-item"
              @click="goLink('https://www.douyin.com/user/MS4wLjABAAAAu5LS4Y6rU92dkeZiUHidZMyPL5fBB3EM_jECrZ664DVZ3l-ambuTroAuBY2ruawo')">
              抖音</div>
          </div>
          <div class="text-nav-r text-list">
            <div v-if="isHome" class="text-item" @click="goAnchor('#contact')">联系我们</div>
            <div v-else class="text-item">联系我们</div>
            <div class="text-item">
              <router-link to="/joinus">加入我们</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-links">
      <div class="footer-links-block footer-container">
        <div class="footer-copyright footer-l-item">
          <div class="copy">皮氏咖啡(上海)有限公司 ©2022 Peets Coffee. <a href="https://beian.miit.gov.cn" target="_blank">沪ICP备17041985号-2</a></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      isHome: false,
      isWechatPopShow: false
    };
  },
  watch: {
    $route(to, from) {
      //console.log(to)
      if (to.name === 'home') {
        this.isHome = true;
      }
    },
    immediate: true
  },
  mounted() {

  },
  methods: {
    goAnchor(selector) {
      document.querySelector(selector).scrollIntoView({
        behavior: "smooth"
      });
    },

    goLink(url) {
      window.open(url, '_blank');
    },

    showWechat() {
      this.isWechatPopShow = true;
    },

    hideWechat() {
      this.isWechatPopShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  &:focus {
    text-decoration: none;
  }

  &:hover {
    text-decoration: none;
  }
}

#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #222;
  overflow: hidden;
  font-size: 14px;
  box-sizing: border-box;
  padding-top: 300px;
  position: relative;
  z-index: 100;

  .footer-container {
    max-width: 1440px;
    margin: 0 auto;
  }

  .footer-main {
    .footer-main-block {

      .footer-mark {
        font-size: 14px;
        color: #8e713c;
        padding-bottom: 140px;

        p {
          margin-bottom: 27px;
          line-height: 21px;
          letter-spacing: 1.6px;

          span {
            font-family: $GoB;
          }
        }
      }

      .footer-logo {
        width: 344px;
        height: 76px;
        margin: 0 auto 158px;

        img {
          width: 100%
        }
      }

      .text-nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f3e9dc;
        padding-bottom: 87px;

        .text-list {
          display: flex;
          align-items: center;

          &.text-nav-r {
            .text-item {
              margin-right: 0;
              margin-left: 55px;
            }
          }

          .text-item {
            margin-right: 55px;
            cursor: pointer;
            position: relative;

            a {
              color: #fff;
            }

            .text-pop {
              padding-top: 5px;
              position: absolute;
              left: 50%;
              transform: translate(-50%, 0);
              top: 90%;
              z-index: 2;
              width: 80px;
              height: 80px;

              img {
                width: 100%;
              }
            }

          }
        }
      }
    }
  }

  .footer-links {

    .footer-links-block {
      padding: 55px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #8e713c;
      .footer-copyright{
        .copy{
          a{
            color: #8e713c;
          }
        }
      }
    }

  }
}

@media screen and (min-width: 768px) and (max-width: 996px) {}


@media screen and (min-width: 997px) and (max-width: 1199px) {}

@media screen and (min-width: 1200px) {}

@media screen and (min-width: 1440px) {}

@media only screen and (max-width: 768px) {}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue